import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

import { getQueryParams } from '../../services/UtilityService';
import { AssessmentModeEnum } from '../../constants/AssessmentsData';
import WGAssessmentsService from '../../services/WGAssessmentsService';
import StudentTemplate from '../report/StudentTemplate';
import GermanTemplate from '../report/GermanTemplate';
import EnglishTemplate from '../report/EnglishTemplate';
import SpanishTemplate from '../report/SpanishTemplate';
import EnglishTemplateV2 from '../report/EnglishTemplateV2';

const AssessmentReport = () => {

    const location = useLocation();
    const params = getQueryParams(location.search);
    const assessment = WGAssessmentsService.getReportData(params);

    const renderContent = () => {
        if (!assessment) {
            return null;
        }

        const {language} = assessment;

        if (assessment?.participant?.roster_mode === AssessmentModeEnum.STUDENT)
            return <StudentTemplate assessment={assessment} />;
        if (language === 'es') {
            return <SpanishTemplate assessment={assessment} />;
        }
        if (language === 'de') {
            return <GermanTemplate assessment={assessment} />;
        }

        return <EnglishTemplateV2 assessment={assessment} />;
    };

    return (
        <>
            <Helmet>
                <meta charSet='UTF-8' />
                <meta name='viewport' content='width=device-width, initial-scale=1.0' />
                <meta httpEquiv='X-UA-Compatible' content='ie=edge' />
                <link rel='stylesheet' href='/report/pdf.css' />
                <title>The 6 Types of Working Genius Assessment Report</title>
            </Helmet>
            {renderContent()}
        </>
    );
};

export default AssessmentReport;
